import globals from "/utils/globals";
import request from "/utils/request";

export default () => request
  .get(globals.promotionsUrl, {
    // Promotion endpoint is not on blinkist domain (s3)
    // We need to make a none XMLHttpRequest request to prevent cors error
    ajax: false
  })
  .then(data => {
    if (data) {
      return data;
    } else {
      throw new Error("No data found in /promotions response");
    }
  });
